import ModulePricingLevelModel from "../models/modulePricing/ModulePricingLevelModel";
import localStorage from "../utilities/localStorage";

export const LOCALSTORAGE_MODULE_PRICING_LEVELS = "modulePricingLevels";

export const getIntervalText = (from?: number, to?: number): string => {
    if ((from === undefined || from === null) && (to === undefined || to === null)) return "Wrong data";

    if (from === undefined || from === null) return `< ${to + 1}`;

    if (to === undefined || to === null) return `>= ${from}`;

    return `>= ${from} and < ${to + 1}`;
};

export const getModulePrice = (noModules: number, modulePricingLevels): number => {
    if (modulePricingLevels?.length === 0) return null;
    if (!noModules) return null;

    const foundLevel: any = Object.values(modulePricingLevels)?.find(
        (level: ModulePricingLevelModel) =>
            noModules >= level.lowLimit && (noModules <= level.highLimit || level.highLimit === null)
    );
    const modulePrice = foundLevel?.modulePrice;
    return modulePrice;
};

export const recalculateModulePrices = items => {
    const modulePricingLevels = localStorage.getJsonItem(LOCALSTORAGE_MODULE_PRICING_LEVELS, {});

    const relevantItems = items?.filter(i => i?.numberOfModules !== undefined);
    if (relevantItems?.length === 0) return items;

    const sumModules = relevantItems
        ?.map(i => i.numberOfModules)
        ?.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    const newModulePrice = getModulePrice(sumModules, modulePricingLevels);
    return items?.map(i =>
        i?.numberOfModules !== undefined ? { ...i, price: newModulePrice * i.numberOfModules } : i
    );
};
